var _defs, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMathsIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.882,
    height: 57.797,
    viewBox: "0 0 31.882 57.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.268,
    y1: 0.171,
    x2: -0.164,
    y2: -0.489,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbb0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff551"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.295,
    y1: 1.249,
    x2: 0.905,
    y2: 0.383,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.85,
    y1: 0.533,
    x2: 1.493,
    y2: 0.593,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 99.959,
    y1: -36.967,
    x2: 72.132,
    y2: -62.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.427,
    y1: -0.006,
    x2: 0.289,
    y2: -1.034,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.42,
    y1: -0.006,
    x2: 0.284,
    y2: -1.034,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085",
    transform: "translate(-41.868 -168.301)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2083",
    "data-name": "Group 2083",
    transform: "translate(44.691 173.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M133.765,191.648h0l.221-.432h0Z",
    transform: "translate(-107.339 -189.311)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    height: 0.486,
    transform: "translate(25.681 2.246)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M131.109,187.569l.221-.432h0l-1.24-1.9-.221.432h0Z",
    transform: "translate(-104.683 -185.232)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M129.917,189.522h0l-.866-1.331h0Z",
    transform: "translate(-104.125 -187.249)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M129.68,195.537l-.221.432h0l.221-.432Z",
    transform: "translate(-104.403 -192.257)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M129.222,189.954l.221-.432h0l-.866-1.331h0l-.221.432h0Z",
    transform: "translate(-103.651 -187.249)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M128.3,192.686h0l-.867-1.331Z",
    transform: "translate(-103.021 -189.406)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M128.064,198.694l-.221.432h0l.221-.432Z",
    transform: "translate(-103.302 -194.409)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M127.6,193.118l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-102.547 -189.406)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1046",
    "data-name": "Rectangle 1046",
    height: 1.588,
    transform: "translate(24.329 2.825)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M126.224,202.291l.221-.432h0Z",
    transform: "translate(-102.198 -196.566)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M125.987,196.275l.221-.432h0l-.866-1.331h0l-.221.432h0Z",
    transform: "translate(-101.446 -191.558)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    width: 1.451,
    transform: "translate(22.224 3.421)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M125.691,207.421l.222-.435h0Z",
    transform: "translate(-101.835 -200.062)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M124.368,199.44l.221-.432h0l-.866-1.331-.221.432Z",
    transform: "translate(-100.342 -193.716)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M119.39,201l1.24,1.9h0l-1.24-1.9-1.45.069h0Z",
    transform: "translate(-96.551 -195.983)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M122.764,209.052l.221-.432-.221.432Z",
    transform: "translate(-99.84 -201.176)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M123.036,203.341l.222-.435h0l-1.24-1.9-.222.435h0Z",
    transform: "translate(-99.18 -195.983)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M121.6,205.769l-.866-1.331h0Z",
    transform: "translate(-98.457 -198.325)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M121.366,211.784l-.221.432h0l.221-.432Z",
    transform: "translate(-98.736 -203.333)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M120.908,206.2l.221-.432-.866-1.331h0l-.221.432h0Z",
    transform: "translate(-97.984 -198.325)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M118.6,257.185l1.449-.069-.584-23.86-1.382,2.83Z",
    transform: "translate(-96.651 -217.971)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1048",
    "data-name": "Rectangle 1048",
    height: 1.588,
    transform: "translate(22.197 6.991)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M119.529,215.374h0l.221-.432h0Z",
    transform: "translate(-97.635 -205.486)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M113.868,209.179Z",
    transform: "translate(-93.775 -201.557)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M119.289,209.366l.221-.432h0l-.866-1.331h0l-.221.432h0Z",
    transform: "translate(-96.88 -200.483)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M117.91,218.538h0l.221-.432h0Z",
    transform: "translate(-96.531 -207.643)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M117.674,212.523l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-95.779 -202.635)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1049",
    "data-name": "Rectangle 1049",
    width: 0.488,
    transform: "translate(21.077 12.312)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M116.054,215.687l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-94.675 -204.792)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M115.421,219.154h0l-1.24-1.9h0Z",
    transform: "translate(-93.989 -207.059)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M114.451,225.3l.221-.432-.221.432Z",
    transform: "translate(-94.172 -212.253)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M114.722,219.589l.222-.435h0l-1.24-1.9h0l-.222.435h0Z",
    transform: "translate(-93.512 -207.059)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M113.281,222.017l-.866-1.331h0Z",
    transform: "translate(-92.781 -209.402)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M113.052,228.032l-.221.432h0l.221-.432Z",
    transform: "translate(-93.068 -214.41)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M112.595,222.449l.221-.432-.866-1.331-.221.432h0Z",
    transform: "translate(-92.316 -209.402)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M111.662,225.181h0l-.866-1.331h0Z",
    transform: "translate(-91.677 -211.559)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M111.216,231.621l.221-.432h0Z",
    transform: "translate(-91.967 -216.562)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M110.975,225.614l.221-.432h0l-.866-1.331-.221.432.5.773Z",
    transform: "translate(-91.212 -211.559)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M109.6,234.786h0l.221-.432h0Z",
    transform: "translate(-90.863 -218.719)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M109.36,228.77l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-90.111 -213.711)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1050",
    "data-name": "Rectangle 1050",
    height: 0.488,
    transform: "translate(18.675 17.239)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M107.741,231.935l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-89.007 -215.868)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M107.107,235.4h0l-1.24-1.9h0Z",
    transform: "translate(-88.321 -218.136)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M106.137,241.548h0l.221-.432h0Z",
    transform: "translate(-88.504 -223.329)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M106.409,235.837l.222-.435h0l-1.24-1.9h0l-.222.435h0Z",
    transform: "translate(-87.845 -218.136)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M104.518,244.707h0l.222-.435h0Z",
    transform: "translate(-87.401 -225.481)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M104.281,238.7l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-86.649 -220.478)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M102.9,247.869l.221-.432-.221.432Z",
    transform: "translate(-86.3 -227.638)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M102.662,241.856l.222-.435h0l-.866-1.331-.222.435h0Z",
    transform: "translate(-85.545 -222.63)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M101.283,251.033l.221-.432-.221.432Z",
    transform: "translate(-85.196 -229.796)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M101.047,245.018l.221-.432-.866-1.331h0l-.221.432h0Z",
    transform: "translate(-84.444 -224.788)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M100.976,255.729l-.221.432h0l.221-.432Z",
    transform: "translate(-84.835 -233.292)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M100.114,247.75l-.866-1.331h0Z",
    transform: "translate(-83.805 -226.945)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M99.427,248.182l.221-.432-.867-1.331-.221.432h0Z",
    transform: "translate(-83.34 -226.945)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1051",
    "data-name": "Rectangle 1051",
    height: 2.272,
    transform: "translate(15.521 20.349)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M97.823,257.8l.221-.432h0Z",
    transform: "translate(-82.837 -234.405)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M98.1,252.082l.221-.432h0l-1.24-1.9h0l-.221.432h0Z",
    transform: "translate(-82.18 -229.212)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1052",
    "data-name": "Rectangle 1052",
    width: 0.488,
    transform: "translate(14.338 24.18)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M95.967,254.944l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-80.981 -231.555)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M95.047,257.669h0l-.866-1.331h0Z",
    transform: "translate(-80.354 -233.707)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M94.81,263.684l-.221.432h0l.221-.432Z",
    transform: "translate(-80.632 -238.715)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M94.348,258.1l.222-.435h0l-.866-1.331h0l-.222.435h0Z",
    transform: "translate(-79.877 -233.707)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1053",
    "data-name": "Rectangle 1053",
    height: 1.588,
    transform: "translate(13.745 23.51)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M93.191,266.849l-.221.432h0l.221-.432Z",
    transform: "translate(-79.528 -240.872)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M92.733,261.266l.221-.432h0l-.866-1.331h0l-.221.432h0Z",
    transform: "translate(-78.776 -235.864)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M92.441,272.409h0l.221-.432h0Z",
    transform: "translate(-79.168 -244.368)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M91.809,264h0l-.866-1.331Z",
    transform: "translate(-78.146 -238.021)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M85.693,264.243h0Z",
    transform: "translate(-74.567 -239.096)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M91.114,264.43l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-77.672 -238.021)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1054",
    "data-name": "Rectangle 1054",
    width: 0.486,
    transform: "translate(12.279 28.516) rotate(-45)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M89.785,268.33l.221-.432h0l-1.24-1.9-.221.432h0Z",
    transform: "translate(-76.512 -240.289)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M89.427,272.417h0l-.363-.557Z",
    transform: "translate(-76.866 -244.288)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M87.891,277.2l.222-.435-.222.435Z",
    transform: "translate(-76.066 -247.634)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M87.654,271.192l.221-.432h0l-.363-.557-.5-.773h0l-.221.432h0Z",
    transform: "translate(-75.313 -242.631)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M86.725,273.917l-.866-1.331h0Z",
    transform: "translate(-74.677 -244.783)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M86.5,279.932h0l-.221.432.221-.432Z",
    transform: "translate(-74.964 -249.791)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M86.035,274.351l.222-.435-.867-1.331-.222.435h0Z",
    transform: "translate(-74.21 -244.783)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1055",
    "data-name": "Rectangle 1055",
    height: 1.588,
    transform: "translate(11.099 28.681)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M84.656,283.528h0l.221-.432h0Z",
    transform: "translate(-73.86 -251.948)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M84.641,277.081l-.866-1.331h0l-.221.432.866,1.331.221-.432Z",
    transform: "translate(-73.108 -246.941)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M84.127,288.656h0l.221-.432h0Z",
    transform: "translate(-73.5 -255.444)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M82.3,279.9l.5.773.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-72.005 -249.098)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M83.074,282.024l.5.773h0Z",
    transform: "translate(-72.782 -251.218)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M81.417,289.858l-.221.432h0l.221-.432Z",
    transform: "translate(-71.502 -256.558)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M81.472,284.577l.221-.432h0l-1.24-1.9-.221.432h0Z",
    transform: "translate(-70.844 -251.365)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M80.027,287.007h0l-.866-1.331h0Z",
    transform: "translate(-70.111 -253.708)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M79.577,293.45h0l.222-.435h0Z",
    transform: "translate(-70.398 -258.71)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M79.34,287.44l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-69.646 -253.708)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M77.962,296.612l.221-.432-.221.432Z",
    transform: "translate(-69.297 -260.868)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M77.721,290.6l.222-.435h0l-.866-1.331-.222.435h0Z",
    transform: "translate(-68.542 -255.86)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M76.343,299.771h0l.222-.435h0Z",
    transform: "translate(-68.193 -263.02)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M76.106,293.761l.221-.432L75.461,292l-.221.432h0Z",
    transform: "translate(-67.441 -258.017)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M70.685,293.574h0Z",
    transform: "translate(-64.336 -259.091)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M70.7,293.425l1.445-.069h0Z",
    transform: "translate(-64.345 -258.943)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1056",
    "data-name": "Rectangle 1056",
    width: 0.486,
    transform: "translate(7.849 38.167)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M74.487,296.92l.222-.435h0l-.866-1.331-.222.435Z",
    transform: "translate(-66.337 -260.169)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M76.509,304.472Z",
    transform: "translate(-68.306 -266.521)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M73.133,299.286l-.519-.8h0Z",
    transform: "translate(-65.651 -262.442)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M72.883,306.538h0l.221-.432h0Z",
    transform: "translate(-65.834 -267.635)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M73.158,300.825l.221-.432h0l-.721-1.107-.519-.8h0l-.221.432h0Z",
    transform: "translate(-65.177 -262.442)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M71.486,309.263h0l-.222.435h0Z",
    transform: "translate(-64.73 -269.787)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M71.027,303.687l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-63.978 -264.784)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M69.648,312.859h0l.221-.432h0Z",
    transform: "translate(-63.629 -271.944)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M69.63,306.412l-.866-1.331-.222.435.866,1.331.222-.435Z",
    transform: "translate(-62.875 -266.936)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M65.436,306.447l.866,1.331h0l-.866-1.331-1.45.069h0Z",
    transform: "translate(-59.77 -267.867)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M68.251,315.584l-.222.435h0l.222-.435Z",
    transform: "translate(-62.525 -274.096)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M67.792,310.009l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-61.773 -269.093)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M67.722,320.719l-.221.432h0l.221-.432Z",
    transform: "translate(-62.165 -277.597)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1057",
    "data-name": "Rectangle 1057",
    height: 1.588,
    transform: "translate(5.293 40.028)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M66.173,313.168l.222-.435h0l-.866-1.331h0l-.222.435h0Z",
    transform: "translate(-60.669 -271.246)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M65.531,316.64h0l-1.24-1.9h0Z",
    transform: "translate(-59.974 -273.518)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M64.569,322.786h0l.221-.432h0Z",
    transform: "translate(-60.167 -278.711)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M64.845,317.072l.221-.432h0l-1.24-1.9-.221.432h0Z",
    transform: "translate(-59.509 -273.518)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M62.954,325.943h0l.221-.432h0Z",
    transform: "translate(-59.065 -280.863)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M62.713,319.935l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-58.311 -275.86)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1058",
    "data-name": "Rectangle 1058",
    height: 0.485,
    transform: "translate(3.484 45.628)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M61.1,323.092l.221-.432h0l-.866-1.331-.221.432h0Z",
    transform: "translate(-57.21 -278.012)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M62.03,328.675Z",
    transform: "translate(-58.435 -283.021)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M59.938,331.832l-.222.435h0l.222-.435Z",
    transform: "translate(-56.858 -285.173)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M59.479,326.256l.221-.432h0l-.866-1.331h0l-.221.432h0Z",
    transform: "translate(-56.106 -280.17)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M59.187,337.4h0l.221-.432h0Z",
    transform: "translate(-56.498 -288.674)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M58.55,328.981h0l-.866-1.331h0Z",
    transform: "translate(-55.47 -282.322)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M57.86,329.416l.222-.435h0l-.866-1.331-.222.435h0Z",
    transform: "translate(-55.002 -282.322)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M50.737,332.559h0Z",
    transform: "translate(-50.737 -285.669)",
    fill: "#ff6c7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M56.531,333.32l.221-.432h0l-1.24-1.9-.221.432h0Z",
    transform: "translate(-53.842 -284.594)",
    fill: "#ff6c7b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M76.824,219.5l-.277-16.27L76.33,190.35,76.1,176.629l-.14-8.326L73.2,173.691l1.238,1.9-.22.433-1.241-1.9-.261.509.866,1.33-.22.433-.866-1.33-.3.573.866,1.33-.22.433-.866-1.33-.293.573.866,1.33-.223.433-.866-1.33-.293.573.866,1.334-.22.43-.869-1.33-.318.627,1.238,1.9-.223.436-1.238-1.906-.337.662.866,1.33-.22.433-.869-1.334-.293.576.866,1.33-.22.433-.869-1.33-.293.573.869,1.33-.223.433-.866-1.334-.3.576.869,1.33-.223.433-.866-1.33-.321.627,1.241,1.9-.223.436-1.241-1.906-.337.659.869,1.33-.223.433-.866-1.33-.293.576.866,1.33-.223.433-.363-.557-.5-.773-.293.57.866,1.334-.22.43-.869-1.33-.293.576.866,1.33-.22.433-.866-1.33-.321.624,1.238,1.906-.22.433-1.241-1.9-.337.659.866,1.33-.22.433-.866-1.33-.293.573.866,1.33-.223.433-.866-1.33-.293.573.866,1.33-.223.433-.866-1.33-.293.576.866,1.33-.223.433-.866-1.334-.318.627,1.238,1.906-.22.43-1.241-1.9-.337.662.866,1.33-.223.433-.866-1.33-.293.573.866,1.33-.22.433-.869-1.33-.293.573.869,1.33-.223.433-.866-1.33-.3.573.869,1.334-.223.43-.866-1.33-.321.627,1.241,1.9-.223.433-1.238-1.9-.341.662.506.773.363.557-.223.433-.866-1.334-.293.573.866,1.33-.223.436-.866-1.33-.293.573.866,1.33-.22.433-.869-1.33-.293.573.866,1.33-.22.433-.5-.773-.363-.557-.321.627,1.238,1.9-.22.433L57.18,205l-.337.659.866,1.33-.22.433-.866-1.33-.3.573L57.2,208l-.223.436-.866-1.33-.293.57L56.68,209l-.223.43-.866-1.33-.293.573.866,1.33-.223.436-.866-1.33-.321.624.522.8L56,211.642l-.22.433-1.241-1.906-.337.662.866,1.33-.223.433-.866-1.33-.293.573.866,1.33-.223.436-.866-1.334-.293.573.866,1.33-.22.433-.866-1.33-.293.573.866,1.33-.223.436-.866-1.334-.321.627,1.241,1.906-.223.43-1.238-1.9L51.55,216l.869,1.33-.223.433-.866-1.33-.293.573.866,1.33-.22.433h0l-.866-1.334-.293.576.866,1.33-.22.433-.869-1.33-.293.573.869,1.33-.223.433-.869-1.33-.318.627,1.238,1.9-.22.433-1.241-1.9-2.823,5.516L50.4,225.4l10.7-1.687,5.083-.8,9.79-1.544.882-.14Zm-10.77-6.646-7.89.926.054-.108,11.028-21.55,1.388-2.712.3,12.763.236,10.08Z",
    transform: "translate(-3.103 -0.001)",
    fill: "url(#linear-gradient-2)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2084",
    "data-name": "Group 2084",
    transform: "translate(41.868 168.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M72.855,168.3,43.318,226.027l-1.45.07L71.4,168.372Z",
    transform: "translate(-41.868 -168.301)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M63.408,319.5l-.866-1.331.867,1.331Z",
    transform: "translate(-55.962 -270.472)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M84.852,208.184l-5.4,11.827-.3-12.763-1.388,2.712L66.739,231.51l-.054.108,7.89-.926-4.956,10.856-10.7,1.687,25.7-48.772Z",
    transform: "translate(-11.624 -17.835)",
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M119.152,294.323l-.853,1.865-9.79,1.544,10.366-19.679Z",
    transform: "translate(-45.431 -74.821)",
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathsIcon2);
export default __webpack_public_path__ + "static/media/maths-icon-2.770d5a0f0a220f84c3058cf1b46690f8.svg";
export { ForwardRef as ReactComponent };